import { useState } from 'react';

import { SuperAgentSparkIcon } from '@superfunnel/ui-core/SuperAgentSparkIcon';
import { classNames } from '@superfunnel/ui-core/utils';

import { DropIllustration } from './DropIllustration';

interface FileDropZoneProps {
  hint: string;
  onBrowse: () => void;
  onDropFiles: (files: File[]) => void;
  className?: string;
}

export function FileDropZone({
  hint,
  onBrowse,
  onDropFiles,
  className,
}: FileDropZoneProps) {
  const [dragActive, setDragActive] = useState(false);

  return (
    <button
      type="button"
      onClick={onBrowse}
      onDragOver={(event) => {
        event.preventDefault();
        setDragActive(true);
      }}
      onDragLeave={() => setDragActive(false)}
      onDrop={(event) => {
        event.preventDefault();
        setDragActive(false);
        onDropFiles(Array.from(event.dataTransfer.files ?? []));
      }}
      className={classNames(
        'group flex w-full flex-col items-center justify-center gap-5 rounded-xl border-[1.5px] border-dashed border-brand-300 bg-brand-500/4 px-6 py-10 text-center transition-colors hover:border-brand-500 hover:bg-brand-500/6 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 dark:border-brand-400/60 dark:hover:border-brand-400',
        dragActive && 'border-brand-500 bg-brand-500/8 dark:border-brand-400',
        className,
      )}
    >
      <DropIllustration className="transition-transform duration-slow ease-enter group-hover:-translate-y-0.5 motion-reduce:transition-none" />
      <span className="flex flex-col items-center gap-0.5">
        <span className="text-lg font-medium text-base-900">
          Drag &amp; drop or choose files to upload
        </span>
        <span className="text-xs text-base-500">{hint}</span>
      </span>
    </button>
  );
}

export function FileRequirements({
  requirements,
  className,
}: {
  requirements: string[];
  className?: string;
}) {
  return (
    <div
      className={classNames(
        'flex flex-col items-start gap-1.5 text-left',
        className,
      )}
    >
      <p className="text-sm font-medium text-base-900">File requirements:</p>
      {requirements.map((requirement) => (
        <div key={requirement} className="flex items-center gap-1">
          <SuperAgentSparkIcon
            variant="outline-purple"
            size={16}
            className="shrink-0"
          />
          <p className="text-xs text-base-600">{requirement}</p>
        </div>
      ))}
    </div>
  );
}
